import React from 'react';

// 因為這五館 navbar 過長會跑版，所以用 ESG 代替，其他館正常顯示 SUSTAINABLE
const useEGSHotels = ['jiaoxi', 'ximending', 'sanchong', 'osakaShinsaibashi', 'NTU'];

const NavSustainabilityItem = ({ className, lan, hotel }) => {
	const showNavButton = lan === 'zh-TW' || lan === 'zh-CN' || lan === 'en';
	const link = lan === 'en' ? 'https://esg.silkshotelgroup.com/en' : 'https://esg.silkshotelgroup.com';

	let context;
	if (lan === 'zh-TW') {
		context = '永續發展';
	} else if (lan === 'zh-CN') {
		context = '永续发展';
	} else if (lan === 'en') {
		if (useEGSHotels.includes(hotel)) {
			context = 'ESG';
		} else {
			context = 'SUSTAINABLE';
		}
		
	} 

	if (showNavButton) {
		return (
			<a
				className={className}
				href={link}
				target="_blank"
				rel="noopener noreferrer"
			>
				{context}
			</a>
		);
	}

	return '';
};

export default NavSustainabilityItem;



// WEBPACK FOOTER //
// ./src/components/molecules/NavSustainabilityItem/index.js